import { ReactNode } from 'react';
import styled from 'styled-components';

import { FlexGap, Heading3, Paragraph, tokens } from '@treams/treams-ui';

import OverviewItem, { OverviewTone } from './OverviewItem';

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: ${tokens.gap.list}px;

	@media (max-width: 900px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
`;

export default function OverviewSection(props: {
	title: string;
	description: string;
	tone: OverviewTone;
	items: {
		icon: ReactNode;
		title: string;
		link: string;
		enabled?: boolean;
		upsell?: ReactNode;
	}[];
}) {
	return (
		<FlexGap flexDirection="column" gap={tokens.gap.group} width="100%">
			<FlexGap flexDirection="column" gap={tokens.gap.inline}>
				<Heading3 mb={0}>{props.title}</Heading3>
				<Paragraph mb={0}>{props.description}</Paragraph>
			</FlexGap>
			<Grid>
				{props.items.map((item, index) => (
					<OverviewItem key={index} tone={props.tone} {...item} />
				))}
			</Grid>
		</FlexGap>
	);
}
